function parseBool(v: string | undefined, def: boolean): boolean {
  if (v === undefined) return def;
  const lower = v.toLowerCase();
  if (lower === 'true') return true;
  if (lower === 'false') return false;
  return def; // 不正値は default にフォールバック
}

export const features = {
  enableAudio: parseBool(process.env.REACT_APP_ENABLE_AUDIO, true),
} as const;
